export { default } from "ordinal";
